import React from 'react';
import styled from 'styled-components';
import StreamingMaterials from '../class/streaming/StreamingMaterials';

const TestMaterials: React.FC = () => {
  return (
    <Container>
      <Header>
        <Title>강의자료 테스트</Title>
      </Header>
      <Content>
        <StreamingMaterials />
      </Content>
    </Container>
  );
};

const Container = styled.div`
  width: 100%;
  min-height: 100vh;
  padding: 20px;
  background: white;
`;

const Header = styled.div`
  margin-bottom: 32px;
`;

const Title = styled.h1`
  color: #171719;
  font-size: 24px;
  font-family: 'Pretendard JP', sans-serif;
  font-weight: 600;
  margin: 0;
`;

const Content = styled.div`
  max-width: 480px;
  padding: 16px;
  border: 1px solid #e0e0e0;
  border-radius: 12px;
`;

export default TestMaterials;
